<div *ngIf="field && field.invalid && (field.dirty || field.touched)">
  <div *ngFor="let err of keys(messages)">
    <div *ngIf="field.errors && field.errors[err]">
      <p-message severity="error" [text]="messages[err]" closable="false"></p-message>
    </div>
  </div>
</div>
